import gql from 'graphql-tag';
import { companyFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const importCompaniesMutation = gql`
  mutation ImportCompanies($input: CompanyImportInput!) {
    importCompanies(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminCompanyFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${companyFieldsFragment}
`;